<template>
  <div>
    <collapsibleItem>
      <div slot="heading">形状设置</div>
      <div slot="body" class="bar-color-sets mt8">
        <div class="data-item">
          <label class="font14 inlineMiddle mr8">形状</label>
          <el-select v-model="symbolType" class="percent65_ height32">
            <el-option
              v-for="(item, index) in shapeStyleList"
              :key="index"
              :selected="symbolType == item.value"
              :value="item.value"
              :label="item.title"
              >{{ item.title }}
            </el-option>
          </el-select>
        </div>
        <div class="data-item mt16" v-if="symbolType === 'autoImage'">
          <img-upload-simple :imgSrc.sync="symbolImage" />
        </div>
        <div class="data-item mt16">
          <double-input
            title="尺寸"
            placeHolderText="必填"
            :value1.sync="symbolSize[0]"
            :value2.sync="symbolSize[1]"
            :inputSuffixs="['宽', '高']"
          />
        </div>
        <div class="data-item mt16">
          <p class="font14 mb8">形状间隔</p>
          <slider-and-input
            :value.sync="symbolMargin"
            title=""
            titlePosition="singleLine"
            :sliderMax="100"
            suffix="px"
          />
        </div>
        <div class="data-item mt16">
          <p class="font14 mb8">角度</p>
          <slider-and-input
            :value.sync="symbolRotate"
            title=""
            titlePosition="singleLine"
            :sliderMax="360"
            suffix="度"
          />
        </div>
        <div class="data-item mt16">
          <p class="font14 mb8">柱体透明度</p>
          <slider-and-input :value.sync="opacity" title="" titlePosition="singleLine" :sliderMax="100" suffix="%" />
        </div>
        <div class="data-item mt16" v-if="symbolType !== 'autoImage'">
          <div class="verticallyCenter mb16">
            <div class="font14 flex1">柱体颜色</div>
            <div class="tabs-color">
              <span
                :class="barColorType === 'single' ? 'tabs-color-item active' : 'tabs-color-item'"
                @click="changeColorType('single')"
              >
                单色</span
              >
              <span
                :class="barColorType === 'multi' ? 'tabs-color-item active' : 'tabs-color-item'"
                @click="changeColorType('multi')"
                >多色</span
              >
            </div>
          </div>
          <div class="color-container mb16" v-for="(colorItem, index) in barColorList" :key="index">
            <div>
              <el-radio-group v-model="colorItem.type" @change="changeColorQuantity(index, colorItem.type)">
                <el-radio label="纯色">纯色</el-radio>
                <el-radio label="线性渐变">线性渐变</el-radio>
              </el-radio-group>
            </div>
            <color-picker v-if="colorItem.type === '纯色'" class="mt8" :color.sync="colorItem.color" />
            <div v-if="colorItem.type !== '纯色'">
              <color-picker
                class="mt12"
                :color.sync="colorItem.startColor"
                title="开始颜色"
                titlePosition="singleLine"
              />
              <color-picker class="mt8" :color.sync="colorItem.endColor" title="结束颜色" titlePosition="singleLine" />
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">文本设置</div>
      <div slot="body" class="mt8">
        <cx-check-box :value.sync="showLabel">显示文本</cx-check-box>
        <div class="mt16" v-if="showLabel">
          <!-- 字体和颜色/字重和字号 -->
          <text-setting-update
            class="mb16 nextlinemt8"
            :fontColor.sync="labelFontColor"
            :fontFamily.sync="labelFontFamily"
            :fontSize.sync="labelFontSize"
            :fontWeight.sync="labelFontWeight"
            colorMode="chart"
          />
          <div class="mt16" v-if="checkType(textPosition)">
            <cx-select title="位置" :selectOptions="textPositionList" :value.sync="textPosition" />
            <div class="mt8" v-if="textPosition === 'const'">
              <double-input
                placeHolderText="必填"
                :value1.sync="absolutePosition1"
                :value2.sync="absolutePosition2"
                inputSuffixs="px"
              />
            </div>
          </div>
          <div class="mt16" v-if="checkType(showLabelUnit)">
            <cx-check-box :value.sync="showLabelUnit">显示单位</cx-check-box>
            <div class="mt16" v-if="showLabelUnit">
              <span class="font14 mr10 half-label">显示单位</span>
              <el-input
                class="width-half-bigWidth el-input el-input--suffix"
                placeholder="请输入"
                v-model="showLabelUnitValue"
              >
              </el-input>
            </div>
            <!-- 字体和颜色 -->
            <!--字重和字号 -->
            <div
              class="mt16"
              v-if="showLabelUnit && (checkType(labelUnitValueFontWeight) || checkType(labelUnitValueFontColor))"
            >
              <text-setting-update
                class="mb16 nextlinemt8"
                :fontColor.sync="labelUnitValueFontColor"
                :fontFamily.sync="labelUnitValueFontFamily"
                :fontSize.sync="labelUnitValueFontSize"
                :fontWeight.sync="labelUnitValueFontWeight"
                colorMode="chart"
              />
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem v-if="seriesDataLen === 1">
      <div slot="heading">排序设置</div>
      <div slot="body" class="mt8">
        <cx-check-box :value.sync="realtimeSort">开启排序</cx-check-box>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">最值设置</div>
      <div slot="body" class="mt8">
        <cx-check-box :value.sync="maximumSet" class="mb16">开启最值设置</cx-check-box>
        <div class="color-container mb16" v-if="maximumSet">
          <p class="font14 mb8">最大值</p>
          <div>
            <el-radio-group v-model="barMaxColor.type" @change="changeColorMaxMinQuantity('max', barMaxColor.type)">
              <el-radio label="纯色">纯色</el-radio>
              <el-radio label="线性渐变">线性渐变</el-radio>
            </el-radio-group>
          </div>
          <color-picker
            v-if="barMaxColor.type === '纯色' && barMaxColor.color"
            class="mt8"
            :color.sync="barMaxColor.color"
          />
          <div v-if="barMaxColor.type !== '纯色' && barMaxColor.startColor && barMaxColor.endColor">
            <color-picker
              class="mt12"
              :color.sync="barMaxColor.startColor"
              title="开始颜色"
              titlePosition="singleLine"
            />
            <color-picker class="mt8" :color.sync="barMaxColor.endColor" title="结束颜色" titlePosition="singleLine" />
          </div>
        </div>
        <div class="color-container mb16" v-if="maximumSet">
          <p class="font14 mb8">最小值</p>
          <div>
            <el-radio-group v-model="barMinColor.type" @change="changeColorMaxMinQuantity('min', barMinColor.type)">
              <el-radio label="纯色">纯色</el-radio>
              <el-radio label="线性渐变">线性渐变</el-radio>
            </el-radio-group>
          </div>
          <color-picker
            v-if="barMinColor.type === '纯色' && barMinColor.color"
            class="mt8"
            :color.sync="barMinColor.color"
          />
          <div v-if="barMinColor.type !== '纯色' && barMinColor.startColor && barMinColor.endColor">
            <color-picker
              class="mt12"
              :color.sync="barMinColor.startColor"
              title="开始颜色"
              titlePosition="singleLine"
            />
            <color-picker class="mt8" :color.sync="barMinColor.endColor" title="结束颜色" titlePosition="singleLine" />
          </div>
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
import publicData from "../publicData"

export default {
  mixins: [publicData],

  props: {
    options: {
      type: Object
    },
    seriesSettingItem: {
      type: Object
    },
    index: {
      type: Number
    },
    ids: {
      type: Object
    },
    seriesDataLen: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      barColorType: undefined,
      barColorList: [],
      this1: this,
      verticalTextPositionList: [
        {
          label: "外部顶部",
          value: "top"
        },
        {
          label: "内部顶部",
          value: "insideTop"
        },
        {
          label: "内部中部",
          value: "inside"
        },
        {
          label: "内部底部",
          value: "insideBottom"
        }
      ],
      horizontalTextPositionList: [
        {
          label: "外部右",
          value: "right"
        },
        {
          label: "外部左",
          value: "left"
        },
        {
          label: "外部上",
          value: "top"
        },
        {
          label: "外部下",
          value: "bottom"
        },
        {
          label: "内部左",
          value: "insideLeft"
        },
        {
          label: "内部中",
          value: "inside"
        },
        {
          label: "内部右",
          value: "insideRight"
        },
        {
          label: "内部上",
          value: "insideBottom"
        },
        {
          label: "内部下",
          value: "insideTop"
        },
        {
          label: "自定义",
          value: "const"
        }
      ],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      maxIdx: 0,
      minIdx: 0,
      barMaxColor: {},
      barMinColor: {},
      shapeStyleList: [
        {
          title: "直角矩形",
          value: "rect"
        },
        {
          title: "圆角矩形",
          value: "roundRect"
        },
        {
          title: "圆形",
          value: "circle"
        },
        {
          title: "三角形",
          value: "triangle"
        },
        {
          title: "菱形",
          value: "diamond"
        },
        {
          title: "气球",
          value: "pin"
        },
        {
          title: "箭头",
          value: "arrow"
        },
        {
          title: "自定义图片",
          value: "autoImage"
        }
      ]
    }
  },
  created() {
    this.init()
  },
  watch: {
    ids: {
      deep: true,
      handler(val, oloVal) {
        this.init()
      }
    },
    barColorType: {
      deep: true,
      handler(val, oldval) {
        let params = JSON.parse(JSON.stringify(this.seriesSettingItem))
        if (val === "multi") {
          // 隐藏图例的显示
          this.$changeOptionsEV(false, "chartOption.legend.show", false)
          this.$changeOptionsEV(params, "chartOption.series." + this.index, false)
        }
      }
    },
    barColorList: {
      deep: true,
      handler(val, oldval) {
        if (val.length == 0) return
        let params = JSON.parse(JSON.stringify(this.seriesSettingItem))
        // 格式化数据
        let x = 0,
          y = 0,
          // 横轴
          x2 = 0,
          y2 = 0
        if (this.options.chartOption.seriesTempAttributes.coordinateType === "rectangular") {
          let xAxisType = this.options.chartOption.xAxis.type
          x = 0
          y = 0
          // 横轴
          x2 = xAxisType === "value" ? 1 : 0
          y2 = xAxisType === "value" ? 0 : 1
        } else {
          let radiusAxisType = this.options.chartOption.radiusAxis.type
          x = 0
          y = 0
          // 横轴
          x2 = radiusAxisType === "value" ? 1 : 0
          y2 = radiusAxisType === "value" ? 0 : 1
        }
        if (this.barColorType === "multi") {
          val.forEach((item, index) => {
            let dataIndex
            let seriesData = JSON.parse(JSON.stringify(this.seriesSettingItem.data))
            let data = seriesData.sort(this.sortNum)
            // 数据展示的时候进行了自动排序，所以数据中的索引和 颜色的索引是不一样的
            let currentData = data[index]
            for (let i = 0; i < seriesData.length; i++) {
              if (seriesData[i].value == currentData.value) {
                dataIndex = i
                break
              }
            }
            let colorItem
            if (item.type === "线性渐变") {
              colorItem = {
                type: "linear",
                x: x,
                y: y,
                x2: x2,
                y2: y2,
                colorStops: [
                  {
                    offset: 0,
                    color: item.startColor || item.color // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: item.endColor || item.color // 100% 处的颜色
                  }
                ]
              }
            } else {
              colorItem = item.color || item.startColor
            }
            params.data[index].itemStyle.color = colorItem
          })
        } else {
          let colorGlobe
          if (val[0].type === "线性渐变") {
            colorGlobe = {
              type: "linear",
              x: x,
              y: y,
              x2: x2,
              y2: y2,
              colorStops: [
                {
                  offset: 0,
                  color: val[0].startColor || val[0].color // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: val[0].endColor || val[0].color // 100% 处的颜色
                }
              ]
            }
          } else {
            colorGlobe = val[0].color || val[0].startColor
          }
          params.itemStyle.color = colorGlobe
          // 清除多色设置
          oldval.forEach((item, index) => {
            let colorItem = {}
            params.data[index].itemStyle = colorItem
          })
        }
        this.$changeOptionsEV(params, "chartOption.series." + this.index, false)
        this.resetLegendBorderColor(params)
      }
    },
    barMaxColor: {
      deep: true,
      handler(val, oldval) {
        let params = JSON.parse(JSON.stringify(this.seriesSettingItem))
        // 格式化数据
        let x = 0,
          y = 0,
          // 横轴
          x2 = 0,
          y2 = 0
        if (this.options.chartOption.seriesTempAttributes.coordinateType === "rectangular") {
          let xAxisType = this.options.chartOption.xAxis.type
          x = 0
          y = 0
          // 横轴
          x2 = xAxisType === "value" ? 1 : 0
          y2 = xAxisType === "value" ? 0 : 1
        } else {
          let radiusAxisType = this.options.chartOption.radiusAxis.type
          x = 0
          y = 0
          // 横轴
          x2 = radiusAxisType === "value" ? 1 : 0
          y2 = radiusAxisType === "value" ? 0 : 1
        }
        let colorGlobe
        if (val.type === "线性渐变") {
          colorGlobe = {
            type: "linear",
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            colorStops: [
              {
                offset: 0,
                color: val.startColor || val.color // 0% 处的颜色
              },
              {
                offset: 1,
                color: val.endColor || val.color // 100% 处的颜色
              }
            ]
          }
        } else {
          colorGlobe = val.color || val.startColor
        }
        // 清除之前的设置
        params.data.forEach((item, index) => {
          let colorItem = {}
          if (item.type === "max") {
            params.data[index].itemStyle = colorItem
            params.data[index].type = ""
          }
        })
        params.data[this.maxIdx].itemStyle.color = colorGlobe
        params.data[this.maxIdx].type = "max"
        this.$changeOptionsEV(params, "chartOption.series." + this.index, false)
        this.$changeOptionsEV({ color: colorGlobe }, "chartOption.series." + this.index + ".barMaxColor", false)
        this.resetLegendBorderColor(params)
      }
    },
    barMinColor: {
      deep: true,
      handler(val, oldval) {
        let params = JSON.parse(JSON.stringify(this.seriesSettingItem))
        // 格式化数据
        let x = 0,
          y = 0,
          // 横轴
          x2 = 0,
          y2 = 0
        if (this.options.chartOption.seriesTempAttributes.coordinateType === "rectangular") {
          let xAxisType = this.options.chartOption.xAxis.type
          x = 0
          y = 0
          // 横轴
          x2 = xAxisType === "value" ? 1 : 0
          y2 = xAxisType === "value" ? 0 : 1
        } else {
          let radiusAxisType = this.options.chartOption.radiusAxis.type
          x = 0
          y = 0
          // 横轴
          x2 = radiusAxisType === "value" ? 1 : 0
          y2 = radiusAxisType === "value" ? 0 : 1
        }
        let colorGlobe
        if (val.type === "线性渐变") {
          colorGlobe = {
            type: "linear",
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            colorStops: [
              {
                offset: 0,
                color: val.startColor || val.color // 0% 处的颜色
              },
              {
                offset: 1,
                color: val.endColor || val.color // 100% 处的颜色
              }
            ]
          }
        } else {
          colorGlobe = val.color || val.startColor
        }
        // 清除之前的设置
        params.data.forEach((item, index) => {
          let colorItem = {}
          if (item.type === "min") {
            params.data[index].itemStyle = colorItem
            params.data[index].type = ""
          }
        })
        params.data[this.minIdx].itemStyle.color = colorGlobe
        params.data[this.minIdx].type = "min"
        this.$changeOptionsEV(params, "chartOption.series." + this.index, false)
        this.$changeOptionsEV({ color: colorGlobe }, "chartOption.series." + this.index + ".barMinColor", false)
        this.resetLegendBorderColor(params)
      }
    }
  },
  computed: {
    absolutePosition1: {
      get() {
        return Number(this.hasProperty(this.seriesSettingItem, "label.position.0"))
      },
      set(val) {
        this.$changeOptionsEV(Number(val), "chartOption.series." + this.index + ".label.position.0", false)
      }
    },
    absolutePosition2: {
      get() {
        return Number(-this.hasProperty(this.seriesSettingItem, "label.position.1"))
      },
      set(val) {
        this.$changeOptionsEV(-Number(val), "chartOption.series." + this.index + ".label.position.1", false)
      }
    },
    textPositionList() {
      // 横向柱状图
      if (this.options.chartOption.seriesTempAttributes.coordinateType === "rectangular") {
        if (this.options.chartOption.xAxis.type === "value") {
          return this.horizontalTextPositionList
        } else {
          return this.verticalTextPositionList
        }
      } else {
        if (this.options.chartOption.radiusAxis.type === "value") {
          return this.horizontalTextPositionList
        } else {
          return this.verticalTextPositionList
        }
      }
    },

    // 柱状图是否排序
    realtimeSort: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "realtimeSort", "realtimeSort", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".realtimeSort", false)
      }
    },

    showLabel: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "label.show", "label.show", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.show", false)
      }
    },
    textPosition: {
      get() {
        let position = this.hasProperty(this.seriesSettingItem, "label.position")
        //  如果position为数组，则不进行设置
        if (position && !Array.isArray(position)) {
          return position
        } else {
          return "const"
        }
      },
      set(newVal) {
        if (newVal === "const") {
          this.$changeOptionsEV([10, 0], "chartOption.series." + this.index + ".label.position", false)
        } else {
          this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.position", false)
        }
      }
    },
    labelFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "label.fontFamily", "labelFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontWeight", false)
      }
    },
    labelFontColor: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.color", false)
      }
    },
    showLabelUnitValue: {
      get() {
        this.checkFormatterValue()
        if (this.seriesSettingItem.hasOwnProperty("unit")) {
          return this.seriesSettingItem.unit
        } else {
          const start = this.seriesSettingItem.label.formatter.indexOf("|") + 1
          return this.seriesSettingItem.label.formatter.slice(start, -1)
        }
      },
      set(newVal) {
        this.$changeOptionsEV(
          `{c}{valueUnit|${newVal}}`,
          "chartOption.series." + this.index + ".label.formatter",
          false
        )
        this.$changeOptionsEV(
            newVal,
            "chartOption.series." + this.index + ".unit",
            false
        )
      }
    },
    showLabelUnit: {
      get() {
        this.checkFormatterValue()
        if (this.seriesSettingItem.hasOwnProperty("unit")) {
          return !!this.seriesSettingItem.unit
        } else {
          const start = this.seriesSettingItem.label.formatter.indexOf("|") + 1
          return !!this.seriesSettingItem.label.formatter.slice(start, -1)
        }
      },
      set(newVal) {
        if (!newVal) {
          if (this.seriesSettingItem.hasOwnProperty("unit")) {
            this.$changeOptionsEV("", "chartOption.series." + this.index + ".unit", false)
          }
          this.$changeOptionsEV(`{c}{valueUnit|}`, "chartOption.series." + this.index + ".label.formatter", false)
        } else {
          if (this.seriesSettingItem.hasOwnProperty("unit")) {
            this.$changeOptionsEV(" ", "chartOption.series." + this.index + ".unit", false)
          }
          this.$changeOptionsEV(`{c}{valueUnit| }`, "chartOption.series." + this.index + ".label.formatter", false)
        }
      }
    },
    labelUnitValueFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.seriesSettingItem,
          "label.rich.valueUnit.fontFamily",
          "labelUnitValueFontFamily",
          "sans-serif"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontFamily", false)
      }
    },
    labelUnitValueFontSize: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontSize", false)
      }
    },
    labelUnitValueFontWeight: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontWeight", false)
      }
    },
    labelUnitValueFontColor: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.color", false)
      }
    },
    symbolType: {
      get() {
        return this.seriesSettingItem.symbolType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbolType", false)
        if (newVal !== "autoImage") {
          this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbol", false)
        } else {
          this.$changeOptionsEV("image://" + this.symbolImage, "chartOption.series." + this.index + ".symbol", false)
        }
      }
    },
    symbolImage: {
      get() {
        return this.seriesSettingItem.symbolImage || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbolImage", false)
        this.$changeOptionsEV("image://" + newVal, "chartOption.series." + this.index + ".symbol", false)
      }
    },
    symbolSize: {
      get() {
        return this.seriesSettingItem.symbolSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbolSize", false)
      }
    },
    symbolMargin: {
      get() {
        return this.seriesSettingItem.symbolMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbolMargin", false)
      }
    },
    symbolRotate: {
      get() {
        return this.seriesSettingItem.symbolRotate
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbolRotate", false)
      }
    },
    opacity: {
      get() {
        return Math.round(this.seriesSettingItem.itemStyle.opacity * 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "chartOption.series." + this.index + ".itemStyle.opacity", false)
      }
    },
    // 柱状图是否开启最值设置
    maximumSet: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "maximumSet", "maximumSet", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".maximumSet", false)
        if (newVal) {
          this.initMaxMinColor()
        } else {
          this.initDefaultColor()
        }
      }
    }
  },
  methods: {
    init() {
      this.initBarColorType()
      this.initBarColorList()
      if (this.maximumSet) {
        this.initMaxMinColor()
      }
    },
    // 单色： single; 多色： multi
    initBarColorType() {
      if (this.seriesSettingItem.data[0].itemStyle.color) {
        this.barColorType = "multi"
      } else {
        this.barColorType = "single"
      }
    },
    // 初始化barColorList
    initBarColorList() {
      let result = []
      if (this.barColorType === "single") {
        // 纯色
        const color = this.seriesSettingItem.itemStyle.color
        let obj = {}
        if (typeof color === "string") {
          obj = {
            type: "纯色",
            color: color
          }
        } else if (color.type === "linear") {
          // 线性渐变色
          obj = {
            type: "线性渐变",
            startColor: color.colorStops[0].color,
            endColor: color.colorStops[1].color
          }
        } else {
        }
        result.push(obj)
      } else {
        this.seriesSettingItem.data.forEach(item => {
          // 纯色
          let obj = {}
          if (typeof item.itemStyle.color === "string") {
            obj = {
              type: "纯色",
              color: item.itemStyle.color
            }
          } else if (typeof item.itemStyle.color === "object" && item.itemStyle.color.type === "linear") {
            // 线性渐变色
            obj = {
              type: "线性渐变",
              startColor: item.itemStyle.color.colorStops[0].color,
              endColor: item.itemStyle.color.colorStops[1].color
            }
          } else {
            // undefined，默认值为外层this.seriesSettingItem.itemStyle.color
            const colorTemp = this.seriesSettingItem.itemStyle.color
            if (typeof colorTemp === "string") {
              obj = {
                type: "纯色",
                color: colorTemp
              }
            } else {
              obj = {
                type: "线性渐变",
                startColor: colorTemp.colorStops[0].color,
                endColor: colorTemp.colorStops[1].color
              }
            }
          }
          result.push(obj)
        })
      }
      this.barColorList = result
    },
    // 切换单色多色,每次切换的时候都要去修改chartOption，多色设置会覆盖掉单色设置
    changeColorType(flag) {
      if (this.barColorType != flag) {
        this.barColorType = flag
        this.initBarColorList()
      }
    },
    changeColorQuantity(index, colorItemType) {
      if (colorItemType === "纯色") {
        this.$set(this.barColorList[index], "color", this.barColorList[index].startColor)
      } else {
        this.$set(this.barColorList[index], "startColor", this.barColorList[index].color)
        this.$set(this.barColorList[index], "endColor", this.barColorList[index].color)
      }
    },
    checkFormatterValue() {
      if (!this.seriesSettingItem.label.formatter) {
        this.$changeOptionsEV("{c}{valueUnit| }", "chartOption.series." + this.index + ".label.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.series." + this.index + ".label.rich",
          false
        )
      }
    },
    // 重置legend图标的边框颜色
    resetLegendBorderColor(param) {
      let legendData = this.options.chartOption.legend.data
      let legendBorderColorType =
        typeof legendData !== "undefined" &&
        legendData[0].hasOwnProperty("itemStyle") &&
        legendData[0].itemStyle.hasOwnProperty("color") &&
        legendData[0].itemStyle.color === "transparent"
          ? "custom"
          : "default"
      if (legendBorderColorType === "custom") {
        let series = this.options.chartOption.series
        series.forEach((item, index) => {
          let oldItemStyle = legendData
            ? typeof legendData[index] === "object"
              ? { ...legendData[index] }
              : { name: legendData[index] }
            : {}
          let itemStyle = {
            ...oldItemStyle,
            itemStyle: {
              color: "transparent",
              borderWidth: 2,
              borderColor: item.itemStyle.color
            }
          }
          this.$changeOptionsEV(itemStyle, "chartOption.legend.data." + index, false)
        })
      }
    },
    // 初始化最大最小值设置项
    initMaxMinColor() {
      let dataList = this.seriesSettingItem.data
      this.barMaxColor = {}
      this.barMinColor = {}
      if (dataList?.length > 0) {
        let maxData, minData
        maxData = dataList[0]
        minData = dataList[0]
        let oldMaxData = this.seriesSettingItem.barMaxColor || {}
        let oldMinData = this.seriesSettingItem.barMinColor || {}
        this.maxIdx = 0
        this.minIdx = 0
        dataList.forEach((item, index) => {
          if (Number(item.value) > Number(maxData.value)) {
            maxData = item
            this.maxIdx = index
          }
          if (Number(item.value) < Number(minData.value)) {
            minData = item
            this.minIdx = index
          }
        })
        if (oldMaxData?.itemStyle?.color || maxData?.itemStyle?.color) {
          const color = oldMaxData?.itemStyle?.color || maxData?.itemStyle?.color
          let obj = {}
          if (typeof color === "string") {
            obj = {
              type: "纯色",
              color: color
            }
          } else if (color.type === "linear") {
            // 线性渐变色
            obj = {
              type: "线性渐变",
              startColor: color.colorStops[0]?.color,
              endColor: color.colorStops[1]?.color
            }
          }
          this.barMaxColor = obj
        } else {
          let obj = JSON.parse(JSON.stringify(this.barColorList[0]))
          this.barMaxColor = obj
        }
        if (oldMinData?.itemStyle?.color || minData?.itemStyle?.color) {
          const color = oldMinData?.itemStyle?.color || minData?.itemStyle?.color
          let obj = {}
          if (typeof color === "string") {
            obj = {
              type: "纯色",
              color: color
            }
          } else if (color.type === "linear") {
            // 线性渐变色
            obj = {
              type: "线性渐变",
              startColor: color.colorStops[0]?.color,
              endColor: color.colorStops[1]?.color
            }
          }
          this.barMinColor = obj
        } else {
          let obj = JSON.parse(JSON.stringify(this.barColorList[0]))
          this.barMinColor = obj
        }
      }
    },
    changeColorMaxMinQuantity(type, colorItemType) {
      if (type === "min") {
        if (colorItemType === "纯色") {
          this.$set(this.barMinColor, "color", this.barMinColor.startColor)
        } else {
          this.$set(this.barMinColor, "startColor", this.barMinColor.color)
          this.$set(this.barMinColor, "endColor", this.barMinColor.color)
        }
      }
      if (type === "max") {
        if (colorItemType === "纯色") {
          this.$set(this.barMaxColor, "color", this.barMaxColor.startColor)
        } else {
          this.$set(this.barMaxColor, "startColor", this.barMaxColor.color)
          this.$set(this.barMaxColor, "endColor", this.barMaxColor.color)
        }
      }
    },
    //  取消最值设置后的颜色恢复
    initDefaultColor() {
      let dataList = this.seriesSettingItem.data
      if (dataList?.length > 0) {
        let itemStyleSame = true
        if(this.barColorList?.length > 1){
          itemStyleSame = false
        }
        dataList.forEach((item, index) => {
          if (item.type) {
            if(itemStyleSame){
              item.itemStyle = {}
            }else{
              item.itemStyle.color = this.seriesSettingItem.itemStyle.color
            }
            delete item.type
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.bar-options-setting-dialog .tabs-color {
  width: 88px;
  height: 24px;
  background-color: var(--inputBg);
  border-radius: 4px;
  overflow: hidden;
  padding: 3px 0;
}

.bar-options-setting-dialog .tabs-color .tabs-color-item {
  display: inline-block;
  vertical-align: top;
  border-radius: 3px;
  position: static;
  width: 39.5px;
  height: 18px;
  font-size: 13px;
  line-height: 18px;
  color: var(--iconColor);
  cursor: pointer;
  text-align: center;
  margin-left: 3px;
}

.bar-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--leftMenuBgColor);
  color: var(--themeColor);
}

.bigScreen .bar-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: #575c66;
  color: #ffffff;
}

.bar-font-setting ::v-deep .select_title {
  display: none;
}
</style>
